import React, { useContext } from "react";
import { GlobalDataContext } from "../context/context";
import Directories from "../components/Home/Directories";
import FormHome from "../components/Home/FormHome";
import Map from "../components/Contact/MapContent";
import Modal from "../components/Home/Modal";
import BaseLayout from "../components/global/BaseLayout";
import CounterUp from "../components/global/CounterUp";
import ServicesHome from "../components/Home/ContentServicesHome";
import HeroVideo from "../components/Home/HeroVideo";
import Paletacolor from "../components/global/Paletacolor";
import BlockPrincipal from "../components/block/Block_6";
import BlockSecondary from "../components/block/Block_3";
import BlockAbout from "../components/block/Block_2";
import VideoPromocional from "../components/global/VideoPromocional";
import ContentServices from "../components/Services/ContentServices";
import GalleryContent from "../components/Gallery/GalleryContent";
import ValuesContent from '../components/values/Values_4'
// import ModalPost from "../components/global/Post";


// para agregar la frase de los años de experiencia o la licencia agregar sloganPrincipal={true}
// para agregar la lista de about agregar listsAbout={true}
// para agregar la lista de servicios agregar listsServices={true}

function Home() {
  const { rpdata } = useContext(GlobalDataContext);
  return (
    <BaseLayout PageName="Home">
      <div className="md:max-w-full w-full">


        {/* {
          rpdata?.appoimentImg?.length > 0 ? <ModalPost imgPost={rpdata?.appoimentImg} />
            : null
        } */}


        <Modal />

        <HeroVideo
          urlVideo={'https://firebasestorage.googleapis.com/v0/b/videostock-8dab7.appspot.com/o/video%2Fpool%20cleaning%20stock.mp4?alt=media&token=248e3aeb-407d-40a8-aa1c-139e72f9372a'}
        />

        <div className="bg-[#efefef] w-full py-5">
          <div className="bg-white p-6 max-w-lg mx-auto rounded-lg shadow-md ">
            <div className="flex flex-col justify-center items-center space-x-3">
              <img src="https://firebasestorage.googleapis.com/v0/b/clientesimages.appspot.com/o/Paginas%2F63ee7490d0d92178848cc384%2Fstock%2FOptimum%20Pool%20and%20Spa%2C%20LLC-2024-07-11T19%3A24%3A24.195Z-0.png?alt=media&token=6feceb91-ea44-49ce-b1ce-ff65b5ad884a" alt="Certificate" className="w-44 h-44 rounded-full" />
              <h2 className="text-xl font-semibold text-gray-900">Certification Award</h2>
            </div>
          </div>
        </div>

        <BlockPrincipal
          text={rpdata?.dbHome?.[0].text}
          image1={rpdata?.gallery?.[9]}
          image2={rpdata?.gallery?.[6]}
          image3={rpdata?.gallery?.[7]}
          image4={rpdata?.gallery?.[1]}
          sloganPrincipal={true}
          listsServices={true}
        />

        <ValuesContent />

        {/* video promocional */}
        {
          rpdata?.videosPromo?.[0]?.activo ?
            <VideoPromocional
              title={rpdata?.dbSlogan?.[2]?.slogan}
              text={rpdata?.dbAbout?.[1]?.text}
              linkVideo={`${rpdata?.videosPromo?.[0].link}`}
              image={`${rpdata?.videosPromo?.[0].img}`}
            />
            : null
        }

        <Directories />

        <BlockSecondary
          title={rpdata?.dbSlogan?.[3]?.slogan}
          text={rpdata?.dbHome?.[1]?.text}
          image={rpdata?.gallery?.[14]}
        />

        <CounterUp image={rpdata?.gallery?.[1]} />

        <BlockAbout
          title={'about us'}
          text={rpdata?.dbAbout?.[0]?.text}
          image={rpdata?.gallery?.[4]}
          listsAbout={true}
        />

        {/* our reviews */}
        {
          rpdata?.reviews?.isHomeOnly === true ?
            <div className="w-4/5 mx-auto py-[100px]">
              <h1 className="pb-10 text-center">{rpdata?.labels?.general?.titleReviews}</h1>
              <div className={`${rpdata?.reviews?.links?.[0]}`}></div>
            </div>
            : null
        }

        {/* Servicios del home */}
        {
          rpdata?.simpleWidgets?.[3]?.activo ?
            <div className="pt-20">
              <ContentServices />
            </div>
            :
            <ServicesHome />

        }

        {/* Gallery cuando es OnePages */}

        {/* Paleta de Colores */}
        {
          rpdata?.simpleWidgets?.[3]?.activo ?
            <div className="pt-10 pb-28">
              <h2 className="text-center pb-[50px]">{rpdata?.labels?.general?.titleGallery}</h2>
              <GalleryContent galleryImages={rpdata?.gallery?.length > 0 ? rpdata?.gallery : rpdata?.stock} />
            </div>
            :
            null

        }
        {
          rpdata?.brandingExtra?.[0]?.activo ?
            <Paletacolor />
            : null
        }
        <div
          className="bgFormHome"
          style={{ backgroundImage: `url("${rpdata?.gallery?.[15]}")` }}
        >
          <div className="relative">
            <FormHome />
          </div>
        </div>

        <Map />

      </div>
    </BaseLayout>
  );
}

export default Home;
